export const UNICODE_NO_BREAK_SPACE = '\u00A0';
